var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlowSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 295,
    height: 261,
    viewBox: "0 0 295 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2244",
    filter: "url(#filter0_f_0_208)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.5,
    cy: 130.5,
    rx: 47.5,
    ry: 30.5,
    fill: "url(#paint0_linear_0_208)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_208",
    x: 0,
    y: 0,
    width: 295,
    height: 261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_0_208"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_208",
    x1: 100,
    y1: 161,
    x2: 195,
    y2: 161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166567,
    stopColor: "#F5DCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#F5DCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#F6D5AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#F6D5AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowSm);
export default __webpack_public_path__ + "static/media/glow_sm.143fa9198270cc6a22a375c2c5ea3ebb.svg";
export { ForwardRef as ReactComponent };